import React  from "react";
import classes from "./Modal.module.scss";

export const Modal = ({
    children,
    isShow,
    onClose,
    backgroundColor,
    isCloseOnClickBackground = true,
}) => {
    if (!isShow) return null;

    return (
        <div
            className={classes.wrapper}
            style={{ backgroundColor }}
        >
            <div
                className={classes.content}
                onClick={(e) => {
                    e.stopPropagation();
                    if (isCloseOnClickBackground) onClose();
                }}
            >
                {children}
            </div>
        </div>
    );
};
